import {useAppSelector} from "./useAppSelector";

export const useHasUnsavedChanges = () => useAppSelector(
    state =>
        !!Object.keys(state.changes.changes).length
        || !!Object.keys(state.changes.tagChanges).length
);
